<template lang="pug">
v-dialog(
  v-model="isOpen"
  fullscreen
  hide-overlay
  transition="dialog-bottom-transition"
)
  v-card(color="white")
    .close-btn.rounded-circle
      v-btn(
        icon
        @click="isOpen = false"
      ): v-icon mdi-close
    v-card-text
      v-list(three-line)
        v-list-item(
          v-for="(contact, idx) in contacts"
          :key="idx"
        )
          v-list-item-content
            v-list-item-title
              a.primary--text(:href="`mailto:${contact.email}`"): b {{ contact.email }}
            v-list-item-subtitle.secondary--text
              b {{ contact.region }}
              p {{ contact.organizer }}
</template>

<script>
import contacts from '@/assets/info/regional_organizers_contacts.json';

export default {
  name: 'RegionalContactsDialog',

  data() {
    return {
      isOpen: false,
      contacts,
    };
  },

  created() {
    this.$root.$on('openContactsModal', () => { this.isOpen = true; });
  },
};
</script>

<style lang="scss" scoped>
.close-btn {
  position: fixed;
  right: 0;
  top: 0;
  margin: 32px;
  padding: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: white;
  box-shadow: 0 2px 5px rgba(0, 0, 0, .2);
  z-index: 100;
}
</style>
